if(window.location.href.includes('?build-pack')){
  document.querySelector('.build-pack').classList.add('active-build-pack');
  document.querySelectorAll('.product-bundles .product-bundles-tabs a').forEach(t => t.classList.remove('active'));
  document.querySelector('.product-bundles .product-bundles-tabs .button[data-tab="build-your-pack"]').classList.add('active');
}
if(document.querySelectorAll('.curated-variant input[type="radio"]')) document.querySelectorAll('.curated-variant input[type="radio"]').forEach(radio => {
  radio.addEventListener('change', () => {
    let selectedSize = radio.value.trim();
    document.querySelector('.bundle-add-to-cart .selected-variant').textContent = selectedSize;
    document.querySelectorAll('.product-variant-select').forEach(select => {
      let options = Array.from(select.options);
      let matchedOption = options.find(opt => {
        let parts = opt.text.split('/');
        let sizePart = parts[1]?.trim();
        return sizePart === selectedSize;
      });
      if(matchedOption) select.value = matchedOption.value;
    });
  });
});
if(document.querySelector('.bundle-add-to-cart')) document.querySelector('.bundle-add-to-cart').addEventListener('click', (e) => {
  e.preventDefault();
  let selectedVariants = [];
  document.querySelectorAll('.product-variant-select').forEach(select => {
    if(select.value){
      selectedVariants.push({
        id: select.value,
        quantity: 1
      });
    }
  });
  fetch('/cart/add.js',{
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: selectedVariants })
  })
  .then(response => response.json())
  .then(response => {
    if(response.status){
      document.querySelector('.product-form-error').innerHTML = response.description;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
      },2000);
      return;
    }else{
      if(typeof load_cart == 'function'){
        cartNotification(response.id);
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
      document.querySelector('.bundle-add-to-cart').querySelector('.added-cart').style.display = 'flex';
      document.querySelector('.bundle-add-to-cart').querySelector('.p-add-cart-btn').style.display = 'none';
      setTimeout(function(e){
        document.querySelector('.bundle-add-to-cart').querySelector('.added-cart').style.display = 'none';
        document.querySelector('.bundle-add-to-cart').querySelector('.p-add-cart-btn').style.display = 'flex';
      },2000);
    }
  })
  .catch(error => {
    console.error('Cart error:', error);
  });
});

// if(document.querySelectorAll('.curated-variant input[type="radio"]')) document.querySelectorAll('.curated-variant input[type="radio"]').forEach(radio => {
//   radio.addEventListener('change', () => {
//     // if(radio.checked){
//       let selected_val = radio.value;
//     console.log(selected_val,'selected_val');
//       if(document.querySelectorAll('.selected-variant')) document.querySelectorAll('.selected-variant').forEach((selectedVal) => {
//         selectedVal.textContent = selected_val;
//       })
//       document.querySelectorAll('.option-wrap.bundle').forEach(bundle => {
//         bundle.querySelectorAll('.variant-wrapper input[type="radio"]').forEach(input => {
//           let all_val = input.value;
//           if(selected_val == all_val){
//             input.click();
//           }
//         });
//       });
//     // }
//   });
// });
class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  connectedCallback() {
    var pre = this.querySelector('input[type="radio"]:checked');
    if(pre){
      pre.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  onVariantChange(){
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
      this.updateBuildPackVariant();
    }
  }
  updateBuildPackVariant(){
    if(!this.currentVariant) return;
    document.querySelectorAll('.build-pack li').forEach((buildPack) => {
      const jsonDataElement = buildPack.querySelector('script[type="application/json"]');
      if(!jsonDataElement) return;
      const variantData = JSON.parse(jsonDataElement.textContent);
      const matchedVariant = variantData.find(variant => variant.options.includes(this.currentVariant.option2));
      if(matchedVariant){
        if(matchedVariant.price) buildPack.setAttribute('data-price',matchedVariant.price);
        if(matchedVariant.compare_at_price) buildPack.setAttribute('data-compare-price',matchedVariant.compare_at_price);
        const quantityInput = buildPack.querySelector('.quantity__input');
        if(quantityInput){
          quantityInput.setAttribute('data-quantity-variant-id', matchedVariant.id);
          quantityInput.name = `updates[${matchedVariant.id}]`;
        }
        if(!matchedVariant.available){
          buildPack.classList.add('variant-unavailable');
        }else{
          buildPack.classList.remove('variant-unavailable');
        }
      }
    });
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
    if(this.currentVariant){
      if(document.querySelector('.selected-variant')){
        let optionIndex = parseInt(document.querySelector('.selected-variant').getAttribute('data-option-index'));
        this.currentVariant.options.forEach((value,index) => {
          if(index == optionIndex){
            if(document.querySelectorAll('.selected-variant')) document.querySelectorAll('.selected-variant').forEach((selectedVal) => {
              selectedVal.textContent = value;
            })
          }
        })
      }
    }
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    document.querySelectorAll('.build-pack.active-build-pack .quantity__input').forEach(function(input){
      input.value = 0;
    });
    if(document.querySelector('.build-pack.active-build-pack')){
      let input_val = false;
      document.querySelectorAll('.build-pack.active-build-pack .quantity__input').forEach(function(input){
        if(input.value > 0){
          input_val = true;
        }
      });
      if(input_val){
        if(option_count>=fieldlen){
          if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
            chooseCart.classList.remove('hide-selectore-button');
          });
          if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
            chooseSelector.classList.add('hide-selectore-button');
          });     
        }else{
          if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
            chooseCart.classList.add('hide-selectore-button');
          });
          if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
            chooseSelector.classList.remove('hide-selectore-button');
          });
        }
      }else{
        if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.add('hide-selectore-button');
        });
        if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.remove('hide-selectore-button');
        });
      }
    }else{
      if(option_count>=fieldlen){
        if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.remove('hide-selectore-button');
        });
        if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.add('hide-selectore-button');
        });     
      }else{
        if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.add('hide-selectore-button');
        });
        if(this.closest('.template-product')) this.closest('.template-product').querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.remove('hide-selectore-button');
        });
      }
    }
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span.p-add-cart-btn');
    if(this.currentVariant != undefined){
      if(this.currentVariant.available){
        if(productForm.querySelector(".choose-cart")) productForm.querySelector(".choose-cart").classList.remove('variant_sold-out');
      }else{
        if(productForm.querySelector(".choose-cart")) productForm.querySelector(".choose-cart").classList.add('variant_sold-out'); 
      }
    }
    if(!addButton) return;
    if(!modifyClass) return;
  }
  setUnavailable(){
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span.p-add-cart-btn');
    const price = document.getElementById(`price-${this.dataset.section}`);
  }
  getVariantData(){
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}
if(document.querySelectorAll('.bundle-add-cart')){
  document.querySelectorAll('.bundle-add-cart').forEach(function(addToCart){
    addToCart.addEventListener('click',function(evt){
      evt.preventDefault();
      let items = [];
      document.querySelectorAll('.quantity__input').forEach(input => {
        let variantId = input.getAttribute('data-quantity-variant-id');
        let quantity = parseInt(input.value, 10);
        if(quantity > 0){
          items.push({
            id: variantId,
            quantity: quantity
          });
        }
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        if (data.status) {
          document.querySelector('.product-form-error').innerHTML = data.description;
          setTimeout(function(e){
            document.querySelector('.product-form-error').innerHTML  = '';
          },2000);
          return;
        }else{
          if(typeof load_cart == 'function'){
            cartNotification(data.id);
            load_cart();
            setTimeout(function(e){
              document.querySelector('body').classList.add('open-drawer');
            },500);
            setTimeout(function(e){
              document.querySelectorAll('.build-pack.active-build-pack .quantity__input').forEach(function(input){
                input.value = 0;
              });
            },600);
          }else{
            window.location.href = "/cart";
          }
        }
        evt.target.closest('form').querySelector('.added-cart').style.display = 'flex';
        evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'none';
        setTimeout(function(e){
          evt.target.closest('form').querySelector('.added-cart').style.display = 'none';
          evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'flex';
        },2000);
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });
    });
  });
}
if(document.querySelectorAll('.product-addcart')){
  document.querySelectorAll('.product-addcart').forEach(function(addToCart){
    addToCart.addEventListener('click',function(evt){
      evt.preventDefault();
      // if(document.querySelector('.build-pack')){if(document.querySelector('.build-pack').classList.contains('active-build-pack')){}else{}}else{}
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var cartform = document.querySelector('.product-addcart').closest('form');
      const formData = new FormData(cartform);  
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          document.querySelector('.product-form-error').innerHTML = response.description;
          setTimeout(function(e){
            document.querySelector('.product-form-error').innerHTML  = '';
          },2000);
          return;
        }else{
          if(typeof load_cart == 'function'){
            cartNotification(response.id);
            load_cart();
            setTimeout(function(e){
              document.querySelector('body').classList.add('open-drawer');
            },500);
          }else{
            window.location.href = "/cart";
          }
        }
        evt.target.closest('form').querySelector('.added-cart').style.display = 'flex';
        evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'none';
        setTimeout(function(e){
          evt.target.closest('form').querySelector('.added-cart').style.display = 'none';
          evt.target.closest('form').querySelector('.p-add-cart-btn').style.display = 'flex';
        },2000);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
    
    });
  });
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
var init = false;
var swiper;

// Scrolls the thumb strip so the active thumb stays in view (no edge fades).
function scrollThumbIntoView(thumb, instant){
  if(!thumb) return;
  var inner = thumb.closest('.media-mobile-thumbs-inner');
  if(!inner) return;
  var fade = 4;
  var behavior = instant === true ? 'auto' : 'smooth';
  var thumbLeft = thumb.offsetLeft;
  var thumbRight = thumbLeft + thumb.offsetWidth;
  var viewLeft = inner.scrollLeft;
  var viewRight = viewLeft + inner.clientWidth;
  if(thumbLeft < viewLeft + fade){
    inner.scrollTo({ left: Math.max(0, thumbLeft - fade), behavior: behavior });
  } else if(thumbRight > viewRight - fade){
    inner.scrollTo({ left: thumbRight - inner.clientWidth + fade, behavior: behavior });
  }
}

function swiperCard() {
  if (window.innerWidth <= 991) {
    if (!init) {
      init = true;
      swiper = new Swiper(".media-grid.swiper", {
        direction: "horizontal",
        slidesPerView: "auto",
        centeredSlides: true,
        navigation: {
          nextEl: ".prod-arrows.swiper-button-next",
          prevEl: ".prod-arrows.swiper-button-prev",
        },
        pagination: {
          el: ".product-wrap .swiper-pagination",
          clickable: true,
          hide: true,
        },
        on: {
          init: function(){
            syncMobileThumbsToGallery(this);
          },
          slideChange: function(){
            syncMobileThumbsToGallery(this);
          }
        }
      });
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
function syncMobileThumbsToGallery(sw){
  if(!sw || typeof sw.realIndex !== 'number') return;
  var idx = sw.realIndex;
  var thumbs = document.querySelectorAll('.media-mobile-thumb');
  thumbs.forEach(function(btn, i){
    btn.classList.toggle('is-active', i === idx);
  });
  if(thumbs[idx]) scrollThumbIntoView(thumbs[idx], false);
}
swiperCard();
window.addEventListener("resize", function(){
  swiperCard();
  document.querySelectorAll('.section-product .accordian-content.active').forEach(syncProductAccordionPanelHeight);
});
// Delegated thumbnail click handler — thumbs are hidden on desktop via CSS.
document.addEventListener('click', function(e){
  var thumb = e.target.closest && e.target.closest('.media-mobile-thumb');
  if(!thumb) return;
  e.preventDefault();
  var idx = parseInt(thumb.dataset.slideTo, 10);
  if(isNaN(idx)) return;
  if(swiper && typeof swiper.slideTo === 'function'){
    swiper.slideTo(idx);
  }
});
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  variant_drodown();
});
function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration){
  var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
  var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if(!diff) return
	window.requestAnimationFrame(function step(timestamp){
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if(window.innerWidth < 992) {
    document.querySelectorAll('.choose-selector a').forEach(function(selectBtn){
      selectBtn.addEventListener('click', doScrolling.bind(null, '#product-form-installment', 1000))
    });
  }
}
if(document.querySelector('.color-remian')) document.querySelector('.color-remian').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelectorAll('.grid-meta-color li.hide_colors').forEach((hideColor) => {
    document.querySelector('.color-remian').style.display = 'none';
    hideColor.classList.remove('hide_colors');
  })
})
if(document.querySelector('.mb-color-remian')) document.querySelector('.mb-color-remian').addEventListener('click',function(e){
  e.preventDefault();
  document.querySelectorAll('.grid-meta-color li.mb_hide_colors').forEach((hideColor) => {
    document.querySelector('.mb-color-remian').style.display = 'none';
    hideColor.classList.remove('mb_hide_colors');
  })
})
document.querySelectorAll('.meta-color .grid-meta-color li').forEach((color) => {
  color.addEventListener('mouseover',function(){
    if(window.innerWidth > 991 && color.querySelector('a') != null && document.querySelector('.meta-color-title') != null){
      if(document.querySelector('.meta-color-title span')) document.querySelector('.meta-color-title span').textContent = color.querySelector('a').getAttribute('data-val');
    }
  })
  color.addEventListener('mouseout',function(){
    if(window.innerWidth > 991 && color.querySelector('a') != null && document.querySelector('.meta-color-title') != null){
      if(document.querySelector('.meta-color-title span')) document.querySelector('.meta-color-title span').textContent = document.querySelector('.meta-color a').getAttribute('data-val');
    }
  })
})
let getReview = setInterval(myReview,100);
function myReview(a, b){
  if(document.querySelector('div#shopify-block-okendo_star_rating_Bb8KGx')) document.querySelector('div#shopify-block-okendo_star_rating_Bb8KGx').addEventListener('click', function(e){
    e.preventDefault();
    clearTimeout(getReview);
    document.querySelector('.accordian-wrap[data-title="review"]').classList.add('active');
    var reviewPanel = document.querySelector('.accordian-content[data-title="review"]');
    if(reviewPanel){
      reviewPanel.classList.add('active');
      requestAnimationFrame(function(){ syncProductAccordionPanelHeight(reviewPanel); });
    }
  })
}
function syncProductAccordionPanelHeight(panel){
  if(!panel || !panel.closest('.section-product') || !panel.classList.contains('active')) return;
  var inner = panel.querySelector('.accordian-content-inr');
  if(!inner) return;
  panel.style.maxHeight = Math.ceil(inner.scrollHeight) + 28 + 'px';
}
function ensureAccordionResizeObserver(panel){
  if(!panel || !panel.closest('.section-product') || panel.dataset.accRo === '1') return;
  var inner = panel.querySelector('.accordian-content-inr');
  if(!inner || typeof ResizeObserver === 'undefined') return;
  panel.dataset.accRo = '1';
  var debounceT;
  var ro = new ResizeObserver(function(){
    clearTimeout(debounceT);
    debounceT = setTimeout(function(){
      if(panel.classList.contains('active')) syncProductAccordionPanelHeight(panel);
    }, 40);
  });
  ro.observe(inner);
}
function accordian(){
  const accordions = document.querySelectorAll(".accordian-wrap");
  const openAccordion = (accordion) => {
    let title = accordion.getAttribute('data-title');
    document.querySelectorAll(".accordian-content").forEach((accoContent) => {
      let titles = accoContent.getAttribute('data-title');
      if(titles == title){
        accoContent.classList.add("active");
        if(accoContent.closest('.section-product')){
          accoContent.style.maxHeight = '0px';
          requestAnimationFrame(function(){ syncProductAccordionPanelHeight(accoContent); });
        }
      }
    })
    accordion.classList.add("active");
  };
  const closeAccordion = (accordion) => {
    let title = accordion.getAttribute('data-title');
    document.querySelectorAll(".accordian-content").forEach((accoContent) => {
      let titles = accoContent.getAttribute('data-title');
      if(titles == title){
        if(accoContent.closest('.section-product')){
          accoContent.style.maxHeight = '0px';
        }
        accoContent.classList.remove("active");
      }
    })
    accordion.classList.remove("active");
  };
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector(".accordian-title");
    const content = accordion.querySelector(".accordian-content");
    if(!intro || !content) return;
    intro.onclick = () => {
      const wasOpen = accordion.classList.contains("active");
      accordions.forEach((acc) => closeAccordion(acc));
      if(!wasOpen) openAccordion(accordion);
    };
  });
  document.querySelectorAll('.section-product .accordian-content').forEach(ensureAccordionResizeObserver);
}
accordian();
document.addEventListener("shopify:section:load", function(event) {
  accordian();
});
document.querySelectorAll('.acco-close').forEach(function(accoClose){
  accoClose.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector(".accordian-content.active").classList.remove("active");
    document.querySelector(".accordian-wrap.active").classList.remove("active");
  });
});
window.addEventListener('scroll', function() {
  var div = document.querySelector('.snippet-addto-cart');
  var body = document.body;
  var rect = div.getBoundingClientRect();
  var topOffset = rect.top;
  if (topOffset <= 0) {
    document.querySelector('body').classList.add('stickybar');
    var sectionFooter = document.querySelector('.section-footer');
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var section = sectionFooter.offsetTop - scrollTop - window.innerHeight;
    var Buttons = document.querySelectorAll('.snippet-sticky-product-cart');
    Buttons.forEach(function(button) {
      if(section < 0){
        button.style.display = 'none';
      } else {
        button.style.display = 'block';
      }
    });
  } else {
    document.querySelector('body').classList.remove('stickybar');
  }
});
if(document.querySelector('.model_switch')) document.querySelectorAll('.model_switch a').forEach((switcher) => {
  switcher.addEventListener('click',function(e){
    e.preventDefault();
    document.querySelectorAll('.model_switch a').forEach((switchModel) => {
      switchModel.closest('li').classList.remove('active');
    });
    switcher.closest('li').classList.add('active');
    switcher.closest('.product-media').querySelector('.media-grid').setAttribute('data-val',switcher.closest('li').getAttribute('data-val'));
  });
})
function switchActiveChild() {
  let announce = document.querySelector('.order-shipped');
  if (!announce) return;
  let announceText = announce.querySelectorAll('p');
  let currentActive = announce.querySelector('.active');
  let currentIndex = Array.from(announceText).indexOf(currentActive);
  let nextIndex = (currentIndex + 1) % announceText.length;
  let announceAllActive = document.querySelectorAll(".order-shipped p.active");
  announceAllActive.forEach((announceActive) => {
    announceActive.classList.remove("active");
  });
  announceText[nextIndex].classList.add('active');
}
setInterval(switchActiveChild, 2000);

if(document.querySelector('.choose-selector')) document.querySelector('.choose-selector').addEventListener('click', function() {
  var variantRows = document.querySelectorAll('.variant-row-list');
  variantRows.forEach(function(row) {
      var inputs = row.querySelectorAll('input[type="radio"]');
      var isChecked = Array.from(inputs).some(input => input.checked);
      if (!isChecked) {
          row.classList.add('not-selected');
      } else {
          row.classList.remove('not-selected');
      }
  });
});
if(document.querySelectorAll('.variant-row-list input[type="radio"]')) document.querySelectorAll('.variant-row-list input[type="radio"]').forEach(function(input) {
  input.addEventListener('change', function() {
      var row = input.closest('.variant-row-list');
      var inputs = row.querySelectorAll('input[type="radio"]');
      var isChecked = Array.from(inputs).some(input => input.checked);
      if (isChecked) {
          row.classList.remove('not-selected');
      }
  });
});
if(document.querySelectorAll('.stl-wrapper')) document.querySelectorAll('.stl-wrapper').forEach((stl_wrapper) => {
  stl_wrapper.querySelectorAll('.stl-variant').forEach((stl_variant) => {
    stl_variant.addEventListener('click',function(e){
      e.preventDefault();
      stl_variant.closest('.stl-wrapper').querySelector('.stl-btn').classList.remove('stl-added-error');
      stl_wrapper.querySelectorAll('.stl-variant').forEach((stl_rm_variant) => {
        stl_rm_variant.classList.remove('active');
      });
      stl_variant.classList.add('active');
      if(window.innerWidth > 991){
        let variant_id = stl_variant.dataset.id;
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }else{
            if(typeof load_cart == 'function'){
              cartNotification(response.id);
              load_cart();
            }else{
              window.location.href = "/cart";
            }
          }
          stl_variant.closest('.stl-size').classList.add('stl-add-product');
          stl_variant.closest('.stl-size').querySelector('.stl-selected-size').textContent = stl_variant.querySelector('span').textContent;
          setTimeout(function(e){
            stl_variant.closest('.stl-size').classList.remove('stl-add-product');
            document.querySelector('body').classList.add('open-drawer');
          },1000);
          stl_variant.classList.remove('active');
        })
        .catch((error) => {
          console.error(error);
        });
      }else{
        stl_variant.closest('.stl-wrapper').querySelector('.stl-add .stl-selected-size').textContent = stl_variant.querySelector('span').textContent;
      }
    });
  });
});
if(document.querySelectorAll('.stl-select-add-btn')) document.querySelectorAll('.stl-select-add-btn').forEach((stl_mb_add_select) => {
  stl_mb_add_select.addEventListener('click',function(e){
    e.preventDefault();
    stl_mb_add_select.closest('.stl-btn').classList.add('stl-added-error');
  });
});
if(document.querySelectorAll('.stl-add_btn')) document.querySelectorAll('.stl-add_btn').forEach((stl_mb_add) => {
  stl_mb_add.addEventListener('click',function(e){
    e.preventDefault();
    let variant_id = stl_mb_add.closest('.stl-wrapper').querySelector('.stl-variant.active').dataset.id;
    let formData = {
      'items': [{
        'id': variant_id,
        'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        stl_mb_add.closest('.stl-btn').classList.add('stl-added-error');
        return;
      }else{
        if(typeof load_cart == 'function'){
          cartNotification(response.id);
          load_cart();
        }else{
          window.location.href = "/cart";
        }
      }
      stl_mb_add.closest('.stl-wrapper').querySelector('.stl-size').classList.add('stl-add-product');
      stl_mb_add.classList.add('stl-added-mb');
      stl_mb_add.closest('.stl-wrapper').querySelector('.stl-add .stl-selected-size').textContent = stl_mb_add.closest('.stl-wrapper').querySelector('.stl-variant.active span').textContent;
      stl_mb_add.closest('.stl-wrapper').querySelector('.stl-size .stl-selected-size').textContent = stl_mb_add.closest('.stl-wrapper').querySelector('.stl-variant.active span').textContent;
      setTimeout(function(e){
        stl_mb_add.closest('.stl-wrapper').querySelector('.stl-size').classList.remove('stl-add-product');
        stl_mb_add.classList.remove('stl-added-mb');
        stl_mb_add.closest('.stl-wrapper').querySelector('.stl-variant.active').classList.remove('active');
      },1000);
    })
    .catch((error) => {
      console.error(error);
    });
  });
});
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = document.querySelector('.shop-currency').textContent;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
class QuantityInput extends HTMLElement{
  constructor(){
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  onInputChange(event){
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    if(document.querySelector('.option-wrap[data-name="size"] input:checked')){
      const previousValue = this.input.value;
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }else{
      document.querySelector('.option-wrap[data-name="size"] .variant-row-list').classList.add("highlight-me"),
      setTimeout( () => document.querySelector('.option-wrap[data-name="size"] .variant-row-list').classList.remove("highlight-me"), 500)
    }
  }
  validateQtyRules(){
    countBundleItemsInCart();
    const value = parseInt(this.input.value);
    if(this.input.min){
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if(this.input.max){
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
    let items_count = 0;
    document.querySelectorAll('.build-pack.active-build-pack .quantity__input').forEach(function(input){
      if(input.value > 0){
        items_count += parseInt(input.value);
      }
    });
    document.querySelectorAll('.item_count').forEach(function(items){
      items.innerHTML = items_count;
    });
    let input_count = 0;
    // let item_price = 0;
    document.querySelectorAll('.build-pack.active-build-pack .quantity__input').forEach(function(input){
      // item_price += parseInt(input.closest('li').getAttribute('data-price') * input.value);
      if(input.value > 0){
        input_count += 1;
      }
    });
    // let total_price =  item_price + parseInt(document.querySelector('.prod-price .price-regular').getAttribute('data-price'));
    // document.querySelectorAll('.prod-price .price-regular').forEach(function(price){
    //   price.textContent = Shopify.formatMoney(total_price);
    // });
    if(input_count > 0){
      if(document.querySelector('.option-wrap[data-name="size"] input:checked')){
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.remove('hide-selectore-button');
        });
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.add('hide-selectore-button');
        });
      }else{
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.add('hide-selectore-button');
        });
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.remove('hide-selectore-button');
        });
      }
    }else{
      if(document.querySelector('.template-product')) document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
        chooseCart.classList.add('hide-selectore-button');
      });
      if(document.querySelector('.template-product')) document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
        chooseSelector.classList.remove('hide-selectore-button');
      });
    }
    // let discounts = document.querySelectorAll('.pb-discount li[data-items]');
    // let landingMessage = document.querySelector('.landing-discount');
    // let reachedMessage = document.querySelector('.discount-reached');
    // let activeSet = false;
    // discounts.forEach(function(discount, index){
    //   let per = parseInt(discount.getAttribute('data-per'));
    //   let items = discount.getAttribute('data-items');
    //   let itemNumbers = items.match(/\d+/g).map(Number);
    //   let msgEl = discount.querySelector('.discount-msg');
    //   let min = itemNumbers[0];
    //   let max = itemNumbers[1] !== undefined ? itemNumbers[1] : Infinity;
    //   if(items_count >= min && items_count <= max && !activeSet){
    //     document.querySelectorAll('.pb-discount li').forEach(t => t.classList.remove('active'));
    //     discount.classList.add('active');
    //     if(max === Infinity){
    //       document.querySelectorAll('.pb-discount li').forEach(t => t.classList.remove('active'));
    //       if(reachedMessage) reachedMessage.classList.add('active');
    //     }else{
    //       let nextDiscount = discounts[index + 1];
    //       let nextPer = nextDiscount ? nextDiscount.getAttribute('data-per') : null;
    //       let remaining = max - items_count + 1;
    //       if(landingMessage && nextPer && remaining > 0){
    //         // landingMessage.textContent = `Add ${remaining} more & Save ${nextPer}%`;
    //       }
    //       msgEl.textContent = `Add ${remaining} more for ${nextPer}% discount`;
    //       // msgEl.textContent = `${remaining} more for ${nextPer}%`;
    //     }
    //     activeSet = true;
    //   }else{
    //     discount.classList.remove('active');
    //     msgEl.textContent = '\u00A0';
    //   }
    // });
    // let itemNumbers = document.querySelector('.pb-discount li[data-items]').getAttribute('data-items').match(/\d+/g).map(Number);
    // let max = itemNumbers[1] !== undefined ? itemNumbers[1] : Infinity;
    // if(items_count <= 0){
    //   document.querySelectorAll('.pb-discount li').forEach(t => t.classList.remove('active'));
    //   if(max){
    //     let nextPer = document.querySelector('.pb-discount li[data-items]') ? document.querySelector('.pb-discount li[data-items]').getAttribute('data-per') : null;
    //     // landingMessage.textContent = `Add ${itemNumbers[1] + 1} more & Save ${nextPer}%`;
    //   }
    // }
  }
}
customElements.define('quantity-input', QuantityInput);
function byp_slider(){
  let byp_swiper = new Swiper(".byp-slide", {
    slidesPerView: 6,
    a11y: false,
    spaceBetween: 2,
    navigation: {
      nextEl: document.querySelector('.byp-slide .swiper-button-next'),
      prevEl: document.querySelector('.byp-slide .swiper-button-prev'),
    },
    breakpoints: {
      320: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1366: {
        slidesPerView: 5,
      },
      1500: {
        slidesPerView: 6,
      },
    },
  });
}
byp_slider();
document.querySelectorAll('.product-bundles .product-bundles-tabs a').forEach(bundles_tab => {
  bundles_tab.addEventListener('click', function(e){
    setTimeout(() => {
      byp_slider();
    }, 100);
    if(bundles_tab.getAttribute('href') == ''){
      e.preventDefault();
      if(bundles_tab.getAttribute('data-tab') == 'build-your-pack'){
        document.getElementById('build-your-pack').classList.add('active-build-pack');
        if(document.querySelector('.option-wrap[data-name="size"] .variant-row-list input:checked')) document.querySelector('.option-wrap[data-name="size"] .variant-row-list input:checked').checked = false;
      }else{
        document.getElementById('build-your-pack').classList.remove('active-build-pack');
      }
    }
    document.querySelectorAll('.build-pack.active-build-pack .quantity__input').forEach(function(input){
      input.value = 0;
    });
    document.querySelectorAll('.build-pack.active-build-pack li.variant-unavailable').forEach(function(unavailable){
      unavailable.classList.remove('variant-unavailable');
    });
    let input_count = 0;
    document.querySelectorAll('.build-pack.active-build-pack .quantity__input').forEach(function(input){
      if(input.value > 0){
        input_count += 1;
      }
    });
    if(document.querySelector('.build-pack').classList.contains('active-build-pack')){
      if(input_count > 0){
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.remove('hide-selectore-button');
        });
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.add('hide-selectore-button');
        });
      }else{
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.add('hide-selectore-button');
        });
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.remove('hide-selectore-button');
        });
      }
    }else{
      if(window.location.href.includes('?variant')){
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.remove('hide-selectore-button');
        });
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.add('hide-selectore-button');
        });
      }else{
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-cart').forEach(function(chooseCart){
          chooseCart.classList.add('hide-selectore-button');
        });
        if(document.querySelector('.template-product')) document.querySelectorAll('.choose-selector').forEach(function(chooseSelector){
          chooseSelector.classList.remove('hide-selectore-button');
        });
      }
    }
    document.querySelectorAll('.product-bundles .product-bundles-tabs a').forEach(t => t.classList.remove('active'));
    bundles_tab.classList.add('active');
  });
});
if(document.querySelectorAll('.pf-colors .meta-color-title a')) document.querySelectorAll('.pf-colors .meta-color-title a').forEach(function(pf_colors){
  pf_colors.addEventListener('click', function(event){
    event.preventDefault();
    pf_colors.closest('.pf-colors .meta-color-title').classList.toggle('active-all-colors');
  })
});
if(document.getElementById('bundle-add-to-cart')) document.getElementById('bundle-add-to-cart').addEventListener('click', function () {
  let selectedRadios = document.querySelectorAll('.bundle-variant input[type="radio"]:checked');
  let items = [];
  selectedRadios.forEach(radio => {
    let variantId = radio.getAttribute('data-variant-id');
    if (variantId) {
      items.push({ id: parseInt(variantId, 10), quantity: 1 });
    }
  });
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({ items: items })
  })
  .then(response => {
    if (!response.ok) throw new Error('Add to cart failed');
    return response.json();
  })
  .then(data => {
    window.location.href = '/cart';
  })
  .catch(error => {
    console.error(error);
    alert('There was a problem adding the bundle to cart.');
  });
});
var global_cart_count = 0;
var rangeCount = {
  "6+": 30,
  "4-5": 20,
  "3-3": 10,
  "0-2": 0,
};

function toUpdateDiscountCount() {
  var item_added = 0;
  var total_price = 0;
  if (document.querySelectorAll('#build-your-pack ul li')) {
    document.querySelectorAll('#build-your-pack ul li').forEach(function (self) {
      const qty = parseInt(self.querySelector('.quantity__input').value) || 0;
      const price = parseInt(self.getAttribute('data-price')) || 0;
      item_added += qty;
      total_price += price * qty;
    });
  }

  var total_item = item_added + global_cart_count;
  let currentDiscount = 0;
  let nextThreshold = null;
  let nextDiscount = null;

  const parsedRanges = Object.keys(rangeCount).map(range => {
    if (range.includes('+')) {
      return { min: parseInt(range), max: Infinity, discount: rangeCount[range] };
    } else {
      const [min, max] = range.split('-').map(Number);
      return { min, max, discount: rangeCount[range] };
    }
  });

  parsedRanges.sort((a, b) => a.min - b.min);

  for (let i = 0; i < parsedRanges.length; i++) {
    const range = parsedRanges[i];
    if (total_item >= range.min && total_item <= range.max) {
      currentDiscount = range.discount;
      if (i + 1 < parsedRanges.length) {
        nextThreshold = parsedRanges[i + 1].min;
        nextDiscount = parsedRanges[i + 1].discount;
      }
      break;
    }
  }

  if (total_item >= parsedRanges[parsedRanges.length - 1].min) {
    currentDiscount = parsedRanges[parsedRanges.length - 1].discount;
    nextThreshold = null;
  }

  if (total_price) {
    document.querySelectorAll('.prod-price').forEach(function (selfInner) {
      if (!selfInner.querySelector('.price-compare')) {
        selfInner.insertAdjacentHTML('afterBegin', '<span class="price-compare" data-compare-price="0" style="display: none;">0</span>');
      }
      if (currentDiscount) {
        selfInner.querySelector('.price-compare').textContent = Shopify.formatMoney(total_price);
        var discountedPrice = total_price - (total_price * currentDiscount / 100);
        selfInner.querySelector('.price-regular').textContent = Shopify.formatMoney(discountedPrice);
        selfInner.querySelector('.price-compare').style.display = 'block';
      } else {
        selfInner.querySelector('.price-regular').textContent = Shopify.formatMoney(total_price);
        if (selfInner.querySelector('.price-compare')) {
          selfInner.querySelector('.price-compare').remove();
        }
      }
    });
  }

  // Update messaging
  const discountEl = document.querySelector('.landing-discount');
  if (discountEl) {
    if (currentDiscount === 0 && nextThreshold !== null) {
      let moreNeeded = nextThreshold - total_item;
      discountEl.innerHTML = `Add ${moreNeeded} more for ${nextDiscount}% discount`;
    } else if (nextThreshold !== null) {
      let moreNeeded = nextThreshold - total_item;
      // discountEl.innerHTML = `${currentDiscount}% off – Add ${moreNeeded} more for ${nextDiscount}% off`;
      document.querySelectorAll('.pb-discount li').forEach(t => t.classList.remove('active'));
      document.querySelector('.pb-discount li[data-per="'+ currentDiscount +'"]').classList.add('active');
      document.querySelector('.pb-discount li[data-per="'+ currentDiscount +'"] .discount-msg').innerHTML = `Add ${moreNeeded} more for ${nextDiscount}% off`;
    } else {
      document.querySelectorAll('.pb-discount li').forEach(t => t.classList.remove('active'));
      document.querySelector('.discount-reached').classList.add('active');
      // discountEl.innerHTML = `${currentDiscount}% off – Highest discount applied`;
    }
  }
}

function countBundleItemsInCart() {
  var matchCount = 0;
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartItems = cart.items;
      cartItems.forEach(cartItem => {
        const found = bundle_products.some(bundleItem => {
          return bundleItem.id == cartItem.product_id || bundleItem.id == cartItem.id;
        });
        if (found) {
          matchCount += cartItem.quantity;
        }
      });
      global_cart_count = matchCount;
      toUpdateDiscountCount();
    })
    .catch(err => {
      console.error("Error fetching cart:", err);
    });
}

function waitForBuildYourPackItems(callback, maxTries = 10, interval = 1000) {
  let tries = 0;
  const checkInterval = setInterval(() => {
    const items = document.querySelectorAll('#build-your-pack ul li');
    if (items.length > 0) {
      clearInterval(checkInterval);
      toUpdateDiscountCount();
      countBundleItemsInCart();
    } else {
      tries++;
      if (tries >= maxTries) {
        clearInterval(checkInterval);
      }
    }
  }, interval);
}

if (document.querySelector('[data-tab="build-your-pack"]')) {
  document.querySelector('[data-tab="build-your-pack"]').addEventListener('click', function () {
    toUpdateDiscountCount();
    countBundleItemsInCart();
  });
}

waitForBuildYourPackItems();

document.querySelectorAll('#build-your-pack ul li').forEach(function (self) {
  self.querySelector('.quantity__input').addEventListener('change', function (event) {
    event.preventDefault();
    toUpdateDiscountCount();
  });
});

// Wait for Faslet to load, but stop after 5 seconds
let fasletRetryCount = 0;
const fasletMaxRetries = 25; // 25 * 200ms = 5000ms = 5 seconds
function setupFasletHooks() {
  if (window._faslet) {
    // Show SIZE HELP when button is shown
    window._faslet.onButtonShow = function() {
      document.querySelectorAll('.size-help-container .size-help-title').forEach(function(el) {
      el.style.display = 'block';
      });
    };
  } else if (fasletRetryCount < fasletMaxRetries) {
    fasletRetryCount++;
    setTimeout(setupFasletHooks, 200);
  } else {
    console.log('Faslet widget did not load after 5 seconds.');
  }
}
setupFasletHooks();

document.querySelector('.sticky-addto-cart')?.addEventListener('click', function (e) {
  e.preventDefault();

  const target = document.querySelector('.snippet-addto-cart');
  if (target) {
    const targetRect = target.getBoundingClientRect();
    const scrollY = window.scrollY || window.pageYOffset;
    const offset = targetRect.bottom + scrollY - window.innerHeight;

    const start = window.scrollY;
    const distance = offset - start;
    const duration = 500;
    let startTime = null;

    function animation(currentTime) {
      if (!startTime) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      const ease = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;

      window.scrollTo(0, start + distance * ease);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    }

    requestAnimationFrame(animation);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  var socialProofBlocks = document.querySelectorAll(".social-proof-usp");
  var productIdsDone = {};
  socialProofBlocks.forEach(function (el) {
    var productId = el.getAttribute("data-product-id");
    if (!productId || productIdsDone[productId]) return;
    productIdsDone[productId] = true;
    var min = parseInt(el.dataset.min, 10) || 1;
    var max = parseInt(el.dataset.max, 10) || 99;
    if (max < min) max = min;
    var cookieKey = "sp_" + productId;
    var match = document.cookie.match(new RegExp("(^| )" + cookieKey + "=([^;]+)"));
    var number = match ? match[2] : null;
    if (!number) {
      number = Math.floor(Math.random() * (max - min + 1)) + min;
      var expires = new Date();
      expires.setTime(expires.getTime() + 86400000);
      document.cookie = cookieKey + "=" + number + ";expires=" + expires.toUTCString() + ";path=/";
    }
    document.querySelectorAll('.social-proof-usp[data-product-id="' + productId + '"]').forEach(function (block) {
      var span = block.querySelector(".social-proof-number");
      if (span) span.textContent = number + " ";
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const snippet = document.querySelector(".snippet-addto-cart");

  if (!snippet) return;

  let lastScroll = window.scrollY;

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function checkVisibility() {
    const rect = snippet.getBoundingClientRect();
    const currentScroll = window.scrollY;
    const scrollingDown = currentScroll > lastScroll;

    if (isInViewport(snippet)) {
      body.classList.remove("not-visible");
    } else {
      if (scrollingDown && rect.top < 0 && rect.bottom < 0) {
        body.classList.remove("not-visible");
      } else if (scrollingDown && rect.top >= window.innerHeight) {
        body.classList.add("not-visible");
      } else if (!scrollingDown && rect.bottom <= 0) {
        body.classList.remove("not-visible");
      } else if (!scrollingDown && rect.top >= window.innerHeight) {
        body.classList.add("not-visible");
      }
    }

    lastScroll = currentScroll;
  }

  if (!isInViewport(snippet)) {
    body.classList.add("not-visible");
  }

  window.addEventListener("scroll", checkVisibility);
});